import React from 'react'
// cols es el parametro cols=3
const Tr = ({ children, title="", cols, gap, dist=[], separad= false}) => {
  return (
    <div className='flex flex-col'>
    <label className={title?'text-white text-xl mb-2':'hidden'}>{title}</label>
    <div className={separad ? `grid grid-cols-${cols} gap-${gap}`: `grid grid-cols-${cols} gap-${gap}`}>
        {children.map((e, index) => (
          <div className={separad ? `flex-grid col-span-${dist[index] || 1} ` : `grid col-span-${dist[index] || 1} `}>
            {e}
          </div>
        ))}
    </div>
    </div>
  )
}

export default Tr